import { render, staticRenderFns } from "./Inline.vue?vue&type=template&id=54fe231c&scoped=true&"
import script from "./Inline.vue?vue&type=script&lang=js&"
export * from "./Inline.vue?vue&type=script&lang=js&"
import style0 from "./Inline.vue?vue&type=style&index=0&id=54fe231c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fe231c",
  null
  
)

/* custom blocks */
import block0 from "./Inline.vue?vue&type=custom&index=0&blockType=meta"
if (typeof block0 === 'function') block0(component)
import block1 from "./Inline.vue?vue&type=custom&index=1&blockType=example"
if (typeof block1 === 'function') block1(component)

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('Inline', component.exports)
}
export default component.exports